export const EmptyBoxIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="65" height="41">
		<path
			fill="#F5F5F5"
			d="M32 40.5c17.673 0 32-3.134 32-7s-14.327-7-32-7c-11.09 0-20.863 1.234-26.604 3.109C1.988 30.722 0 32.06 0 33.5c0 3.866 14.327 7 32 7Z"
		/>
		<path
			fill="none"
			stroke="#D9D9D9"
			d="M55 13.26 44.854 1.758C44.367.974 43.656.5 42.907.5H21.093c-.749 0-1.46.474-1.947 1.257L9 13.261V22.5h46v-9.24Z"
		/>
		<path
			fill="#FAFAFA"
			d="M20.16 13.5c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913 0-1.612.994-2.938 2.227-2.938H55v18.137c0 2.122-1.32 3.863-2.95 3.863h-40.1C10.32 35.5 9 33.759 9 31.637V13.5h11.16Z"
		/>
		<path
			fill="none"
			stroke="#D9D9D9"
			d="M20.16 13.5c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913 0-1.612.994-2.938 2.227-2.938H55v18.137c0 2.122-1.32 3.863-2.95 3.863h-40.1C10.32 35.5 9 33.759 9 31.637V13.5h11.16Z"
		/>
	</svg>
);
